import { useState, useContext, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../../../contexts/AuthContext";
import "./MaqPagamentosAdm.css";
import CustomDateRangePicker from "../CustomDatePicker/CustomRangePicker";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import * as links from "../../../../../utils/links";
import moment from "moment";
import PagamentosTable from "../Table/PagamentosTable";
import Swal from "sweetalert2";
export default function MaqPagamentosAdm() {

  const location = useLocation();
  const locationState = location.state || {};
  const [maquinaInfos, setMaquinaInfos] = useState(locationState?.maquinaInfos || {});
  const clienteInfo = locationState?.clienteInfo || {};

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [estornos, setEstornos] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [listCanals, setListCanals] = useState([]);
  const [estoque, setEstoque] = useState("");
  const [dataInicio, setDataInicio] = useState(locationState?.dataInicio || null);
  const [dataFim, setDataFim] = useState(locationState?.dataFim || null);
  const [cash, setCash] = useState("");
  const [total, setTotal] = useState("");
  const [totalLiquido, setTotalLiquido] = useState("");
  const [totalPix, setTotalPix] = useState("");
  const [totalDebito, setTotalDebito] = useState("");
  const [totalCredito, setTotalCredito] = useState("");
  const [taxas, setTaxas] = useState({ PIX: 0, CREDITO: 0, DEBITO: 0 });

  const { id } = useParams();

  const premiosEntregues = Array.isArray(listCanals)
    ? listCanals.reduce((acc, t) => {
        const idStr = t?.mercadoPagoId ? String(t.mercadoPagoId).toLowerCase() : "";
        if (!idStr.includes("saiu premio") && String(t?.tipo || "").toUpperCase() !== "SAIDA_PRODUTO") return acc;
        const s = String(t?.operadora || "");
        const m = s.match(/Saiu\s+(\d+)/i);
        const qtd = m && m[1] ? Number(m[1]) || 1 : 1;
        return acc + qtd;
      }, 0)
    : 0;

  useEffect(() => {
    if (!id?.trim()) return;
    if ((dataInicio && !dataFim) || (!dataInicio && dataFim)) return;
    if (dataInicio && dataFim) {
      getPaymentsPeriod(dataInicio, dataFim);
      return;
    }
    getData(id);
  }, [id, dataInicio, dataFim]);

  const filtrarPagamentosPorPeriodo = (pagamentos = [], inicio, fim) => {
    if (!Array.isArray(pagamentos)) return [];
    if (!inicio || !fim) return pagamentos;

    const dataInicial = moment(inicio).startOf("day");
    const dataFinal = moment(fim).endOf("day");

    return pagamentos.filter((pagamento) => {
      if (!pagamento?.data) return false;
      const dataPagamento = moment(pagamento.data);
      return dataPagamento.isValid() && dataPagamento.isBetween(dataInicial, dataFinal, undefined, "[]");
    });
  };


  const getPaymentsPeriod = (dataInicio, dataFim) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      const url = `${process.env.REACT_APP_SERVIDOR}/pagamentos-periodo-adm/${id}`;

      // const dataInicioISO = dataInicio ? moment(dataInicio).startOf("day").toISOString() : null;
      // const dataFimISO = dataFim ? moment(dataFim).endOf("day").toISOString() : null;

      let dataInicioISO = null;
      let dataFimISO = null;

      if (dataInicio) {
        // dataInicioISO = moment(dataInicio).startOf("day").toISOString();
        dataInicioISO = `${moment(dataInicio).format('YYYY-MM-DD')}T03:00:00.000Z`;
      }

      if (dataFim) {
        // dataFimISO = moment(dataFim).toISOString();
        const dataFimObj = new Date(dataFim);
        dataFimObj.setDate(dataFimObj.getDate() + 1);
        dataFimISO = `${dataFimObj.toISOString().split("T")[0]}T02:59:59.999Z`;
      }

      const requestBody = {};
      if (dataInicioISO) requestBody.dataInicio = dataInicioISO;
      if (dataFimISO) requestBody.dataFim = dataFimISO;
      axios.post(
        url,
        requestBody,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      ).then((res) => {
        setLoadingTable(false);
        setEstornos(res.data.estornos);
        setCash(res?.data?.cash);
        setTotal(res.data.totalBruto)
        setTotalLiquido(res.data.totalLiquido)
        setTotalDebito(res.data.totalCartaoDebito)
        setTotalCredito(res.data.totalCartaoCredito)
        setTotalPix(res.data.totalPix)
        setTaxas({
          CREDITO: res.data.taxaCartaoCredito,
          DEBITO: res.data.taxaCartaoDebito,
          PIX: res.data.taxaPix
        })
        if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
          // setListCanals(filtrarPagamentosPorPeriodo(res.data.pagamentos, dataInicio, dataFim));
          setListCanals(res.data.pagamentos)
        }
      }).catch((err) => {
        setLoadingTable(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser.key === 'ADMIN') {
            navigate(links.ADMIN_SIGNIN);
            setDataUser(null);
          } else {
            navigate(links.SIGNIN);
            setDataUser(null);
          }
        }
      });
    }
  };

  const getData = (id) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      axios
        .get(`${process.env.REACT_APP_SERVIDOR}/pagamentos-adm/${id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          setLoadingTable(false);
          setEstornos(res.data.estornos)
          setCash(res?.data?.cash);
          setTotal(res.data.totalBruto)
          setTotalLiquido(res.data.totalLiquido)
          setTotalDebito(res.data.totalCartaoDebito)
          setTotalCredito(res.data.totalCartaoCredito)
          setTotalPix(res.data.totalPix)
          setTaxas({
            CREDITO: res.data.taxaCartaoCredito,
            DEBITO: res.data.taxaCartaoDebito,
            PIX: res.data.taxaPix
          })
          if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
            // setListCanals(filtrarPagamentosPorPeriodo(res.data.pagamentos, dataInicio, dataFim));
            setListCanals(res.data.pagamentos)
          }
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            setNotiMessage({
              type: "error",
              message:
                "A sua sessão expirou, para continuar faça login novamente.",
            });
            if (dataUser.key === 'ADMIN') {
              navigate(links.ADMIN_SIGNIN)
              setDataUser(null);
            } else {
              navigate(links.SIGNIN)
              setDataUser(null);
            }
          }
        });
    }
  };

  const onRelatorioHandler = () => {
    if (!dataInicio || !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendário a data de início e fim para gerar o relatório para essa maquina!",
      });
    } else {
      navigate(`${links.RELATORIO_ADMIN}/${id}`, {
        state: { maquinaInfos, clienteInfo, dataInicio, dataFim },
      });
    }
  };

  const onRelatorioDispHandler = () => {
    if (!dataInicio || !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendário a data de início e fim para gerar o relatório para essa maquina!",
      });
    } else {
      navigate(`${links.RELATORIO_DISP_ADMIN}/${id}`, {
        state: { maquinaInfos, clienteInfo, dataInicio, dataFim },
      });
    }
  };

  const removerPagamento = async (item) => {
    Swal.fire({
      title: "Deseja remover o pagamento " + item?.mercadoPagoId,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Sim",
      denyButtonText: `Não`
    }).then((result) => {
      if (result.isConfirmed) {
        mensagemLoading('Removendo pagamento..')
        axios.delete(`${process.env.REACT_APP_SERVIDOR}/delete-pagamento/${item.id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }).then((res) => {
          mensagemSucesso('Pagamento removido com sucesso')
        }).catch((err) => {
          mensagemErro('Erro ao remover pagamento')
        });
      }
    });
  };

  function mensagemAlerta(msg) {
    Swal.fire('Alerta', msg, 'warning')
  }
  function mensagemSucesso(msg) {
    Swal.fire('Sucesso', msg, 'success').then(() => {
      setListCanals([])
      getData(id);
    })
  }
  function mensagemErro(msg) {
    Swal.fire('Erro', msg, 'error')
  }
  function mensagemLoading(msg) {
    Swal.fire({
      title: 'Aguarde',
      html: msg,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
  }

  return (
    <div className="MaqPagamentos_container container mw-100">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h4 fw-bold">{maquinaInfos?.nome}</h1>
        <div className="d-flex col-6 col-md-auto mb-2">
          <button className="custom-btn btn btn-outline-secondary"
            onClick={() =>
              navigate(`${links.CLIENTES_MAQUINAS}/${clienteInfo.id}`, {
                state: location.state.clienteInfo,
              })
            }>VOLTAR</button>
        </div>
      </div>
      <div className="d-flex justify-content-start align-items-center mb-4">
        <div className="d-flex flex-wrap">
          <CustomDateRangePicker
            setDataFim={setDataFim}
            setDataInicio={setDataInicio}
            value={{ dataInicio, dataFim }}
          />
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
              onClick={() => {
                navigate(`${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/${id}`, {
                  state: location.state,
                });
              }}>
              <i className="bi bi-pencil" style={{ marginRight: '5px' }}></i>
              Editar Máquina
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => {
              navigate(`${links.CREDITO_REMOTO_ADM}/${maquinaInfos.id}`, {
                state: location.state,
              });
            }}>
              <i className="bi bi-credit-card" style={{ marginRight: '5px' }}></i> Crédito Remoto
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button
              className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
              onClick={() => {
                const url = `https://www.mercadopago.com.br/stores/detail?store_id=${maquinaInfos.store_id}`;
                window.open(url, '_blank');
              }}
            >
              <i className="bi bi-qr-code" style={{ marginRight: '10px' }}></i>
              QR Code
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => onRelatorioHandler()}>
              <i className="bi bi-file-earmark-text" style={{ marginRight: '10px' }}></i>
              Rel. de Pagamentos
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2" onClick={() => onRelatorioDispHandler()}>
              <i className="bi bi-file-bar-graph" style={{ marginRight: '10px' }}></i>
              Rel. de Disponibilidade
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-primary d-flex w-100 mb-2"
              onClick={() => {
                navigate(`${links.CLIENTES_MAQUINAS_TROCAR}/${id}`, {
                  state: location.state,
                });
              }}>
              <i className="bi bi-arrow-counterclockwise" style={{ marginRight: '10px' }}></i>
              Trocar ID
            </button>
          </div>
          <div className="d-flex col-7 col-md-auto">
            <button className="custom-btn btn btn-outline-danger d-flex w-100 mb-2"
              onClick={() => {
                navigate(`${links.CLIENTES_MAQUINA_DELETE_PAGAMENTOS}/${id}`, {
                  state: location.state,
                });
              }}>
              <i className="bi bi-trash" style={{ marginRight: '5px' }}></i>
              Excluir Pagamentos
            </button>
          </div>
        </div>
      </div>


      {/* Filtros */}
      {/* <div className="d-flex justify-content-start align-items-center mb-4">
        <div className="d-flex flex-wrap gap-2">
          <CustomDateRangePicker/>
          <div className="d-flex col-6 col-md-auto">
            <input type="date" className="form-control w-100 mb-2" />
          </div>
          <div className="d-flex col-6 col-md-auto">
            <button className="custom-btn btn btn-outline-primary w-100 mb-2">Rel. de Pagamentos</button>
          </div>
          <div className="d-flex col-6 col-md-auto">
            <button className="custom-btn btn btn-outline-primary w-100 mb-2">Rel. de Disponibilidade</button>
          </div>
        </div>
      </div> */}

      {/* Cards */}
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4">
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Total Bruto</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(total)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Total Líquido</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(totalLiquido)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Pix</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              })?.format(totalPix)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Débito</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              })?.format(totalDebito)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Crédito</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              })?.format(totalCredito)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Espécie</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(cash)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Estornos</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              })?.format(estornos)}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Prêmios entregues</h6>
              <h5 className="fw-bold">{premiosEntregues}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Total Taxas</h6>
              <h5 className="fw-bold">- {Number((taxas.PIX + taxas.CREDITO + taxas.DEBITO).toFixed(2))}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Pulso</h6>
              <h5 className="fw-bold">{Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(maquinaInfos?.pulso)}</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-4">
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Store ID</h6>
              <h5 className="fw-bold">{maquinaInfos?.store_id}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Maquininha</h6>
              <h5 className="fw-bold">{maquinaInfos?.maquininha_serial ? maquinaInfos?.maquininha_serial : '-'}</h5>
            </div>
          </div>
        </div>
        <div className="col-7 col-lg-3 mb-2">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="text-muted">Estoque</h6>
              <h5 className="fw-bold">{estoque}</h5>
            </div>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div className="card" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
        <div className="card-header">
          <h5>{`${maquinaInfos?.nome} - ${maquinaInfos?.descricao}`}</h5>
        </div>
        <div className="card-body">
          <PagamentosTable onRemove={removerPagamento} listCanals={listCanals} />
        </div>
      </div>
    </div>
  );
}
